import React from 'react';

import './styles.css';

const NotActiveTag: React.FC<{content: string}> = ({ content }) => (
  <span className="custom-tag--light-grey">{content}</span>
);

export default NotActiveTag;
